import { render } from "./SearchResultContract.vue?vue&type=template&id=993bacac&scoped=true"
import script from "./SearchResultContract.vue?vue&type=script&lang=js"
export * from "./SearchResultContract.vue?vue&type=script&lang=js"

import "./SearchResultContract.vue?vue&type=style&index=0&id=993bacac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-993bacac"]])

export default __exports__